import { RoofShape } from "../roof/RoofShape"

export function getCurrentRoofHeight(a: number, d: number, iRoofShape: number): number {
    var nRoofHeight: number = 0;
    if (iRoofShape == RoofShape.PULT) {
        nRoofHeight = a;
    } else if (iRoofShape == RoofShape.SATTEL) {
        nRoofHeight = a;
    } else if (iRoofShape == RoofShape.WALM) {
        nRoofHeight = a;
    } else if (iRoofShape == RoofShape.SCHED) {
        nRoofHeight = a;
    } else if (iRoofShape == RoofShape.KRUEPPELWALM) {
        nRoofHeight = a + d;
    } else if (iRoofShape == RoofShape.MANSARD) {
        nRoofHeight = a;
    }
    return nRoofHeight; 
}

export function getCurrentRoofWidth(b: number, iRoofShape: number): number {
    var nRoofWidth: number = 0;
    if (iRoofShape == RoofShape.PULT) {
        nRoofWidth = b;
    } else if (iRoofShape == RoofShape.SATTEL) {
        nRoofWidth = b;
    } else if (iRoofShape == RoofShape.WALM) {
        nRoofWidth = b;
    } else if (iRoofShape == RoofShape.SCHED) {
        nRoofWidth = b;
    } else if (iRoofShape == RoofShape.KRUEPPELWALM) {
        nRoofWidth = b;
    } else if (iRoofShape == RoofShape.MANSARD) {
        nRoofWidth = b;
    }
    return nRoofWidth;
}
